import { API, axiosInstance } from "lib";


export const getAppVersion = (data={}) => {
    return axiosInstance
      .get(API.GET_APP_VERSION , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
        }
        throw err;
      });
  };

  export const updateAppVersion = (data={}) => {
    return axiosInstance
      .post(API.UPDATE_APP_VERSION , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
        }
        throw err;
      });
  };